import Loadable from '../../components/loadable';

const AbsentAttendance = Loadable({
  loader: () => import('../../pages/dashboard/attendance/absent_attendance/absent_attendance'),
  type: 'block',
});

angular.module('gym').value('AbsentAttendance', AbsentAttendance);

const ExcludeFromAbsentAttendancesReportModal = Loadable({
  loader: () =>
    import('../../pages/dashboard/attendance/absent_attendance/exclude_from_absent_attendances_report_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('ExcludeFromAbsentAttendancesReportModal', ExcludeFromAbsentAttendancesReportModal);

const AbsentAttendancesReportExclusionsModal = Loadable({
  loader: () =>
    import('../../pages/dashboard/attendance/absent_attendance/absent_attendances_report_exclusions_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('AbsentAttendancesReportExclusionsModal', AbsentAttendancesReportExclusionsModal);
